import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HotelService from "../../services/hotel.service";

// **Async Thunks**
export const gethotelList = createAsyncThunk(
  "hotel/gethotelList",
  async (item, thunkApi) => {
    try {
      const response = await HotelService.gethotelList(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editHotelDetails = createAsyncThunk(
  "hotel/editHotel",
  async (item, thunkAPI) => {
    try {
      const response = await HotelService.editHotels(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  hotels: [],
};

// **Slice**
const hotelSlice = createSlice({
  name: "hotel",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Hotel List**
      .addCase(gethotelList.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(gethotelList.fulfilled, (state, action) => {
        state.loading = false;
        state.hotels = action.payload;
      })
      .addCase(gethotelList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Hotel**
      .addCase(editHotelDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(editHotelDetails.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.hotels.findIndex((h) => h.id === action.payload.id);
        if (index !== -1) {
          state.hotels[index] = action.payload;
        }
      })
      .addCase(editHotelDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default hotelSlice.reducer;
